import { r as registerInstance, h, H as Host } from './index-97874de0.js';

const flipTileContentCss = ":host{display:block}";
const IxFlipTileContentStyle0 = flipTileContentCss;

const FlipTileContent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.contentVisible = false;
    }
    render() {
        return h(Host, { key: '4de2b68fabbf622640f0b960d9e87aaa2254f623' }, this.contentVisible ? h("slot", null) : null);
    }
};
FlipTileContent.style = IxFlipTileContentStyle0;

export { FlipTileContent as ix_flip_tile_content };

//# sourceMappingURL=ix-flip-tile-content.entry.js.map